module.exports = __webpack_public_path__ + "6ca1f5383bec987d83adb16f8f79fa3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/picture/Canucks_0.jpg
// module id = 464
// module chunks = 0